module.exports = __webpack_public_path__ + "img/ic-line-text.88dd5415.png";